import React from 'react';

type SplashScreenProps = {
  src: string;
  alt?: string;
};

const SplashScreen: React.FC<SplashScreenProps> = ({ src, alt = 'SBM Fizikus' }) => {
  return (
    <div className='splashOverlay' role="img" aria-label={alt}>
      <img src={src} alt={alt} className='image' />
    </div>
  );
};

export default SplashScreen;
